import Instance from "../../../../Axios";

// New Actions for the app

const DeleteFichaTecnica = (id) => async (dispatch) => {
  await Instance()
    .put(`/energias/fichasTecnicas/${id}`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: "DELETE_FICHA_TECNICA", payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default DeleteFichaTecnica;
